/* Prism theme — story slider, menu, contact overlay, fit-to-screen, forms. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initialHash = location.hash;                       // read before the story rewrites it
  const esc = t => (t == null ? '' : String(t)).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const typing = el => !!el && (/INPUT|TEXTAREA|SELECT/.test(el.tagName) || el.isContentEditable);

  /* ---------- menu panel ---------- */
  const panel = $('#panel'), scrim = $('#scrim'), burger = $('.burger');
  const panelOpen = () => !!panel && panel.dataset.open === 'true';
  function openPanel() { if (!panel) return; panel.dataset.open = 'true'; panel.setAttribute('aria-hidden', 'false'); scrim.classList.add('is-on'); burger.setAttribute('aria-expanded', 'true'); const f = panel.querySelector('a'); f && f.focus(); }
  function closePanel(refocus = true) { if (!panel || !panelOpen()) return; panel.dataset.open = 'false'; panel.setAttribute('aria-hidden', 'true'); scrim.classList.remove('is-on'); burger.setAttribute('aria-expanded', 'false'); if (refocus && burger) burger.focus(); }
  if (panel) { burger.addEventListener('click', openPanel); scrim.addEventListener('click', closePanel); $('.panel__close', panel).addEventListener('click', closePanel); }

  /* ---------- overlays: contact (home page) and seat request (gathering page) ---------- */
  const contact = $('#contact');
  const overlay = contact && !contact.classList.contains('contact--page');
  let contactOpen = false, openEl = null;
  const behind = () => { try { return $$('.header, .bar, .main--stage > .shopify-section:not(:has(.overlay, #contact))'); } catch (e) { return $$('.header, .bar'); } };
  function openOverlay(el) {
    if (!el) return;
    el.dataset.open = 'true'; el.setAttribute('aria-hidden', 'false'); contactOpen = true; openEl = el;
    behind().forEach(b => { b.inert = true; });
    setTimeout(() => { const f = el.querySelector('.form__errors, .form__success, input[type=text]'); f && f.focus(); }, 500);
  }
  function closeOverlay() {
    if (!openEl) return;
    openEl.dataset.open = 'false'; openEl.setAttribute('aria-hidden', 'true'); contactOpen = false; openEl = null;
    behind().forEach(b => { b.inert = false; });
    burger && burger.focus();
  }
  function openContact() { if (!overlay) { if (contact) contact.scrollIntoView(); return; } openOverlay(contact); }
  $$('.contact__close').forEach(c => c.addEventListener('click', closeOverlay));

  /* ---------- contact form: email OR phone, combined name, fallback for Shopify's required email ---------- */
  $$('[data-contact-form]').forEach(form => {
    const email = form.querySelector('input[name="contact[email]"]'), phone = form.querySelector('input[name="contact[phone]"]'), summary = form.querySelector('[data-reach-summary]');
    const first = form.querySelector('input[name="contact[First name]"]'), last = form.querySelector('input[name="contact[Last name]"]'), nameOut = form.querySelector('[data-name-summary]');
    const fillName = () => { if (nameOut) nameOut.value = [first && first.value.trim(), last && last.value.trim()].filter(Boolean).join(' '); };
    [first, last].forEach(el => el && el.addEventListener('input', fillName));
    if (!email || !phone) return;
    [email, phone].forEach(el => el.addEventListener('input', () => email.setCustomValidity('')));
    /* plus-one: a name needs an email, and vice versa */
    const gName = form.querySelector('[data-guest-name]'), gMail = form.querySelector('[data-guest-email]');
    if (gName && gMail) { const sync = () => { const need = !!gName.value.trim(); gMail.required = need; gName.required = !!gMail.value.trim(); gMail.setCustomValidity(''); }; gName.addEventListener('input', sync); gMail.addEventListener('input', sync); }
    let relayed = false;
    form.addEventListener('submit', e => {
      if (relayed) return;                                   // fallback pass: let Shopify take it
      fillName();
      if (gName && gMail && gName.value.trim() && !gMail.value.trim()) { e.preventDefault(); gMail.setCustomValidity(form.dataset.guestError || 'Add your plus-one’s email.'); gMail.reportValidity(); return; }
      email.setCustomValidity('');
      if (!email.value.trim() && !phone.value.trim()) { e.preventDefault(); email.setCustomValidity(form.dataset.reachError || 'Leave an email or a phone number.'); email.reportValidity(); return; }
      if (!email.value.trim()) { email.value = form.dataset.fallbackEmail; if (summary) summary.value = 'Phone only: ' + phone.value.trim(); }
      else if (summary) summary.value = phone.value.trim() ? 'Email + phone' : 'Email';
      /* relay through the email Worker when one is configured; on any failure fall back to Shopify's own form */
      const endpoint = (form.dataset.endpoint || '').trim();
      if (!endpoint || !window.fetch) return;
      e.preventDefault();
      const fd = new FormData(form); fd.append('kind', form.dataset.formKind || 'contact'); fd.append('page', location.href.split('#')[0]);
      form.classList.add('is-sending');
      const ctrl = new AbortController(); const t = setTimeout(() => ctrl.abort(), 9000);
      fetch(endpoint, { method: 'POST', body: fd, signal: ctrl.signal }).then(r => r.json()).then(j => {
        clearTimeout(t); if (!j || !j.ok) throw new Error('relay');
        form.classList.remove('is-sending'); form.classList.add('is-sent');
        const ok = form.querySelector('.form__success'); ok && ok.focus();
      }).catch(() => { clearTimeout(t); form.classList.remove('is-sending'); relayed = true; form.submit(); });
    });
  });

  /* ---------- clicks: goto / open contact / open overlay / close ---------- */
  let goto = null;
  document.addEventListener('click', e => {
    const g = e.target.closest('[data-goto]'); if (g && typeof goto === 'function') { e.preventDefault(); goto(+g.dataset.goto); closePanel(false); return; }
    const o = e.target.closest('[data-open-contact]'); if (o) { if (!overlay) return; e.preventDefault(); closePanel(false); openContact(); return; }   // no overlay on this page → follow the link to /pages/contact
    const ov = e.target.closest('[data-open-overlay]'); if (ov) { const el = document.getElementById(ov.dataset.openOverlay); if (el) { e.preventDefault(); closePanel(false); openOverlay(el); } return; }
    const c = e.target.closest('[data-close-contact], [data-close-overlay]'); if (c) { e.preventDefault(); closeOverlay(); }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { if (panelOpen()) return closePanel(); if (contactOpen) return closeOverlay(); }
  });

  /* ---------- the story ---------- */
  const stage = $('.main--stage');
  const bar = $('#bar');
  let steps = [];
  if (stage) {
    const cfg = bar ? bar.dataset : {};
    const range = $('#range'), thumb = $('#thumb'), dotsEl = $('#dots'), current = $('#current'), lf = $('#label-first'), ll = $('#label-last');
    const motion = cfg.motion !== 'false' && !reduced;
    const floor = parseFloat(cfg.fitFloor) || 0.68;
    const hintText = cfg.hint || '';
    let n = 0, last = 0, dots = [], active = -1, interacted = false;
    const pad = (s, st) => (st && st.dataset.brackets === 'false') ? esc(s) : '(' + esc(s) + ')';
    const hintHTML = hintText ? '<span class="bar__hint" id="hint"><span aria-hidden="true">←</span><span>' + esc(hintText) + '</span></span>' : '';
    const label = st => pad(st.dataset.number, st) + ' ' + esc(st.dataset.title);

    /* bar + menu are built from the chapters on the page; rebuilt when the editor adds/removes/re-renders one */
    function build() {
      steps = $$('.step', stage); n = steps.length; last = n - 1;
      if (bar) {
        bar.hidden = n < 2;
        if (n) { lf.innerHTML = '<b>' + pad(steps[0].dataset.number, steps[0]) + '</b> ' + esc(steps[0].dataset.title); ll.innerHTML = '<b>' + pad(steps[last].dataset.number, steps[last]) + '</b> ' + esc(steps[last].dataset.title); }
        dotsEl.innerHTML = steps.map(() => '<li></li>').join(''); dots = $$('li', dotsEl); range.max = Math.max(0, last);
      }
      const list = $('#panel-story');
      if (list) list.innerHTML = steps.map((st, i) => `<li><a href="#${esc(st.id)}" data-goto="${i}"><span class="num">${esc(st.dataset.number)}</span>${esc(st.dataset.title)}</a></li>`).join('');
      try { localStorage.setItem('prism-chapters', JSON.stringify(steps.map(st => ({ id: st.id, number: st.dataset.number, title: st.dataset.title })))); } catch (e) {}
    }
    function place(v) { if (!bar) return; thumb.style.left = (last ? v / last * 100 : 100) + '%'; dots.forEach((d, i) => d.classList.toggle('is-past', i <= Math.round(v))); }
    function show(i, dir, force) {
      if (!n) return;
      i = Math.max(0, Math.min(last, i));
      if (i === active && !force) return;
      const next = steps[i];
      steps.forEach(st => st !== next && st.classList.remove('is-active'));
      if (motion) next.style.setProperty('--dir', dir > 0 ? '40px' : '-40px');
      next.classList.add('is-active'); next.scrollTop = 0;
      active = i;
      document.documentElement.style.setProperty('--accent', next.dataset.accent);
      if (current) current.innerHTML = (i === 0 || i === last) ? (!interacted ? hintHTML : '') : '<span class="num">' + pad(next.dataset.number, next) + '</span>' + esc(next.dataset.title);
      if (range) range.setAttribute('aria-valuetext', label(next));
      $$('#panel-story a').forEach(a => a.toggleAttribute('aria-current', +a.dataset.goto === i));
      history.replaceState(null, '', '#' + next.id);
    }
    goto = function (i, snap = true) {
      interacted = true;
      i = Math.max(0, Math.min(last, i));
      show(i, i > active ? 1 : -1);
      if (snap && range) { range.value = i; place(i); }
    };
    if (range) {
      range.addEventListener('input', () => { interacted = true; const v = +range.value; place(v); const i = Math.round(v); if (i !== active) show(i, i > active ? 1 : -1); });
      const snap = () => { range.value = active; place(active); };
      range.addEventListener('change', snap); range.addEventListener('pointerup', snap);
      range.addEventListener('keydown', e => {                      // whole chapters from the keyboard, not 0.01 steps
        const k = { ArrowLeft: active - 1, ArrowDown: active - 1, ArrowRight: active + 1, ArrowUp: active + 1, Home: 0, End: last }[e.key];
        if (k === undefined) return; e.preventDefault(); goto(k);
      });
    }
    const busy = () => panelOpen() || contactOpen;
    document.addEventListener('keydown', e => {
      if (busy() || e.target === range || typing(e.target)) return;
      if (e.key === 'ArrowLeft') goto(active - 1); if (e.key === 'ArrowRight') goto(active + 1);
    });
    if (cfg.wheel !== 'false') {
      let lock = 0;
      document.addEventListener('wheel', e => { if (busy() || Math.abs(e.deltaX) < 30 || Math.abs(e.deltaX) < Math.abs(e.deltaY)) return; const now = Date.now(); if (now - lock < 700) return; lock = now; goto(active + (e.deltaX > 0 ? 1 : -1)); }, { passive: true });
    }
    if (cfg.swipe !== 'false') {
      let tx = null, ty = null;
      stage.addEventListener('touchstart', e => { if (busy()) { tx = null; return; } tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchcancel', () => { tx = null; }, { passive: true });
      stage.addEventListener('touchend', e => { if (tx === null || busy()) return; const dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty; tx = null; if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) goto(active + (dx < 0 ? 1 : -1)); }, { passive: true });
    }

    /* fit: on desktop scale a chapter down (never up) so it never scrolls */
    /* when a chapter is scaled down, let it use the width it gave up: max-width grows by the same factor, text reflows wider, so less scaling is needed */
    const BASE_W = 88; // rem, same as .step__inner max-width
    function fit() {
      const desktop = innerWidth >= 900;
      steps.forEach(st => {
        const inner = st.querySelector('.step__inner'); if (!inner) return;
        inner.style.zoom = ''; inner.style.maxWidth = ''; if (!desktop) return;
        const cs = getComputedStyle(st);
        const avail = (st.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom)) * 0.98;
        const measure = () => { inner.style.minHeight = '0'; const h = inner.scrollHeight; inner.style.minHeight = ''; return h; };
        let z = 1;
        for (let pass = 0; pass < 3; pass++) {
          const need = measure();                                   // layout px at the current width (unaffected by zoom)
          const next = Math.min(1, Math.max(floor, avail / need));
          if (Math.abs(next - z) < 0.005 && pass) break;
          z = next;
          inner.style.zoom = z < 1 ? z.toFixed(3) : '';
          inner.style.maxWidth = z < 1 ? (BASE_W / z).toFixed(2) + 'rem' : '';
        }
      });
    }
    addEventListener('resize', fit); addEventListener('load', fit); document.fonts && document.fonts.ready.then(fit); setTimeout(fit, 50);

    /* init: theme setting, or a deep link (#step-003) */
    build();
    if (n) {
      let start = cfg.start === 'first' ? 0 : last;
      const m = initialHash.match(/^#step-(.+)$/); if (m) { const k = steps.findIndex(s => s.id === 'step-' + m[1]); if (k > -1) start = k; }
      show(start, 1); place(start); if (range) range.value = start; interacted = false;
      setTimeout(() => { if (!interacted && (active === 0 || active === last)) { const h = $('#hint'); h && h.classList.add('is-on'); } }, 1800);
    }

    /* theme editor: re-render / add / remove / reorder a chapter, and show the one being edited */
    const refresh = () => { const cur = steps[active]; build(); const k = cur ? steps.indexOf(cur) : -1; const want = k > -1 ? k : Math.min(Math.max(0, active), last); active = -1; show(want, 1, true); place(active); if (range) range.value = active; fit(); };
    const jumpTo = el => { const st = el && el.closest && el.closest('.step') || (el && el.querySelector && el.querySelector('.step')); if (st) { if (!steps.includes(st)) refresh(); goto(steps.indexOf(st)); } };
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(ev => document.addEventListener(ev, e => { if (stage.contains(e.target) || ev.endsWith('reorder')) setTimeout(refresh, 0); }));
    document.addEventListener('shopify:section:select', e => jumpTo(e.target));
    document.addEventListener('shopify:block:select', e => jumpTo(e.target));
  }

  /* other pages: show the same chapter list as the home page — from the cache the home page writes, then refreshed by fetching it */
  const sync = $('#panel-story[data-sync-from]');
  const renderList = (el, root, list) => { el.innerHTML = list.map(c => `<li><a href="${root}/#${esc(c.id)}"><span class="num">${esc(c.number)}</span>${esc(c.title)}</a></li>`).join(''); };
  if (sync && !stage) {
    const root = sync.dataset.syncFrom.replace(/\/$/, '');
    try { const cached = JSON.parse(localStorage.getItem('prism-chapters') || 'null'); if (cached && cached.length) renderList(sync, root, cached); } catch (e) {}
    if (window.fetch) fetch(sync.dataset.syncFrom, { credentials: 'same-origin' }).then(r => r.ok ? r.text() : Promise.reject()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const home = [...doc.querySelectorAll('.main--stage .step')].map(st => ({ id: st.id, number: st.dataset.number, title: st.dataset.title }));
      if (!home.length) return;
      renderList(sync, root, home);
      try { localStorage.setItem('prism-chapters', JSON.stringify(home)); } catch (e) {}
    }).catch(() => {});
  }

  /* open an overlay after a Shopify form round-trip (success or validation error), or from a #contact / #rsvp link */
  const posted = /contact_posted=true/.test(location.search);
  if (overlay && (posted || /^#contact/.test(initialHash) || contact.querySelector('.form__errors'))) { openContact(); if (posted || /^#contact/.test(initialHash)) history.replaceState(null, '', location.pathname); }
  const rsvp = $('#rsvp');
  if (rsvp && (posted || /^#rsvp/.test(initialHash) || rsvp.querySelector('.form__errors'))) { openOverlay(rsvp); history.replaceState(null, '', location.pathname); }

  document.addEventListener('shopify:section:select', e => { const el = e.target.querySelector('.overlay, #contact'); if (el && el !== contact) openOverlay(el); else if (overlay && e.target.contains(contact)) openContact(); });
  document.addEventListener('shopify:section:deselect', e => { if (e.target.querySelector('.overlay, #contact')) closeOverlay(); });

  /* year */
  $$('[data-year]').forEach(el => el.textContent = new Date().getFullYear());
})();
